import React from 'react';
import { Pill } from '../../index';

/**
 * SeverityChip — uniform severity rendering across all compliance
 * slideouts. Used by Remediation findings, Regulatory Changes impact,
 * Attestation rejections, and Control Mapping risk flags.
 *
 * Severity scale (mirrors PolicyRule.severity + RemediationTask.severity):
 *   CRITICAL  — operator action required NOW
 *   HIGH      — schedule remediation within current sprint
 *   MEDIUM    — track to backlog, no urgent action
 *   LOW       — visibility only
 *   INFO      — neutral context
 *
 * Phase B / G321.
 */
export function SeverityChip({ severity, size = 'sm' }) {
  const key = String(severity || '').toUpperCase();
  const tone = key === 'CRITICAL' || key === 'BLOCK' ? 'danger'
             : key === 'HIGH'                        ? 'danger'
             : key === 'MEDIUM' || key === 'WARN'    ? 'warning'
             : key === 'LOW'                         ? 'success'
             :                                         'muted';
  return (
    <Pill tone={tone} size={size} dot={tone !== 'muted'}>
      {key || 'INFO'}
    </Pill>
  );
}

export default SeverityChip;
